import { render, staticRenderFns } from "./invitationSuccess.vue?vue&type=template&id=118b0d19"
import script from "./invitationSuccess.vue?vue&type=script&lang=js"
export * from "./invitationSuccess.vue?vue&type=script&lang=js"
import style0 from "./invitationSuccess.vue?vue&type=style&index=0&id=118b0d19&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports